import styled, { css } from 'styled-components';

import { Text } from '@/nova/components';
import { hoverWash } from '@/nova/theme/mixins';
import { CUST, CUST_ANIM } from '../../../../theme/customizer-tokens';

/** Footer bar: primary CTA always right-aligned; optional secondary toggle left. */
export const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  width: 100%;
`;

/** Left-side "I have my own …" toggle (logo step); pushes the CTA to the right. */
export const Secondary = styled.button`
  margin-right: auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 0;
  border: none;
  background: transparent;
  color: ${CUST.textMuted};
  cursor: pointer;
  transition: filter ${CUST_ANIM.INTERACT_MS}ms ease;

  &:hover {
    filter: brightness(1.25);
  }
`;

export const SecondaryLabel = styled(Text)`
  font-size: 14px;
  line-height: 20px;
  color: ${CUST.textMuted};
  white-space: nowrap;
`;

export const Btn = styled.button<{ $enabled: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 48px;
  padding: 0 24px;
  border: none;
  border-radius: 14px;
  cursor: ${({ $enabled }) => ($enabled ? 'pointer' : 'not-allowed')};
  background: ${({ $enabled }) => ($enabled ? CUST.accent : CUST.ctaDisabledBg)};
  color: ${CUST.ctaText};
  transition: filter ${CUST_ANIM.INTERACT_MS}ms ease;
  /* Cursor-following hover glow + lit hairline ring (shared with the CTA Button). */
  ${hoverWash}
  ${({ $enabled }) =>
    !$enabled &&
    css`
      &:hover::before,
      &:hover::after,
      &:focus-visible::before,
      &:focus-visible::after {
        opacity: 0;
      }
    `}

  &:hover {
    filter: ${({ $enabled }) => ($enabled ? 'brightness(1.06)' : 'none')};
  }
`;

export const Label = styled(Text)`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  white-space: nowrap;
`;